export const documentsRoutes = (apiBase) => ({
  saveDocument: `${apiBase}/documents/upload`,
  saveEnlaces: `${apiBase}/documents/links`,
  getTipoDoc: `${apiBase}/documents/types`,
  getDocuments: (keyword, tipos, page, limit, mime) =>
    `${apiBase}/documents?keyword=${keyword}&tipos=${tipos}&categorias=&page=${page}&limit=${limit}&mime=${mime}`,
  viewDocument: (filename) => `${apiBase}/documents/view?route=${filename}`,
  downloadDocument: (filename) => `${apiBase}/documents/download?route=${filename}`,
});
